import { type FunctionComponent } from 'react';
import { useTranslation } from '../../i18n/resources';
import { PrayingHandsCircle } from '../../icons/PrayingHandsCircle';
import styles from './EmptyChannelList.module.css';

export type EmptyChannelListProps = {
  type: 'ccm_community' | 'ccm_member_sharing';
};

export const EmptyChannelList: FunctionComponent<EmptyChannelListProps> = ({
  type,
}) => {
  const { t } = useTranslation();

  const renderHeader = (): string => {
    switch (type) {
      case 'ccm_community':
        return t('prayerStream', 'no_community_groups_header');
      case 'ccm_member_sharing':
        return t('prayerStream', 'no_share_events_header');
    }
  };

  return (
    <div className={styles.root}>
      <PrayingHandsCircle className={styles.icon} />
      <div className={styles.header}>{renderHeader()}</div>
      {type === 'ccm_community' && (
        <div className={styles.subtext}>
          {t('prayerStream', 'no_community_groups_subtext')}
        </div>
      )}
    </div>
  );
};
